import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import TextField from '@material-ui/core/TextField'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import DeleteIcon from '@material-ui/icons/Delete'
import { IconButton } from '@material-ui/core'
import { FORM_NOTIFICACIONES_CHOFER } from '../../../../config/forms'
import { reduxForm, formValueSelector, Field } from 'redux-form'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { renderDateMaterialField } from '../../../Forms/fieldRenderers'
import Grid from '@material-ui/core/Grid'
import { required } from '../../../Forms/fieldValidators'
import moment from 'moment'
import 'moment/locale/es'

const selector = formValueSelector(FORM_NOTIFICACIONES_CHOFER)

class CampoNotificacionChofer extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.changeVencimiento = this.changeVencimiento.bind(this)
    this.changePrioridad = this.changePrioridad.bind(this)
    this.eliminar = this.eliminar.bind(this)
    this.state = { viewNotificacion: false }
  }

  componentDidMount () {
    const { change: formChange } = this.props
    moment.locale()
    const vencimientoDefault = moment().add(1, 'days').format('YYYY/MM/DD')
    console.log('default', vencimientoDefault)
    formChange('vencimiento', vencimientoDefault)
    formChange('prioridad', 0)
  }

  handleSubmit (e) {
    e.preventDefault()
    const {
      submitNotificacion,
      notificacionNueva,
      vencimiento,
      prioridad,
      change: formChange
    } = this.props
    submitNotificacion(notificacionNueva, vencimiento, prioridad)
    const vencimientoDefault = moment().add(1, 'days').format('YYYY/MM/DD')
    formChange('vencimiento', vencimientoDefault)
    formChange('notificacion', '')
    document.querySelector('#outlined-multiline-static').value = ''
    document.querySelector('#vistaConsulta').src = document.querySelector('#vistaConsulta').src
  }

  handleChange (event) {
    const { change: formChange } = this.props
    formChange('notificacion', event.target.value)
  }

  changeVencimiento (vencimiento) {
    const { change: formChange } = this.props
    formChange('vencimiento', vencimiento)
  }

  changePrioridad (event) {
    const { change: formChange } = this.props
    if (event.target.checked) {
      formChange('prioridad', 1)
    } else {
      formChange('prioridad', 0)
    }
  }

  eliminar (n) {
    const { deleteNotificacion } = this.props
    deleteNotificacion(n.fechaEmision)
    document.querySelector('#vistaConsulta').src = document.querySelector('#vistaConsulta').src
  }

  render () {
    const { notificacionesChofer, vencimiento } = this.props

    const notificaciones = []
    notificacionesChofer.map((notificacionChofer) => (
      notificaciones.push(notificacionChofer)
    ))

    const urlConsulta = `${process.env.REACT_APP_LARIDAE}consultaCupo`
    // const urlConsulta = `http://localhost:3000/laridae/ingreso/consultaCupo`

    return (
      <div className='container-notificaciones'>
        <div className='container-funcionalidad-notificacion'>
          <Card className='shadow bg-white rounded card-notificacion-chofer'>
            <form onSubmit={this.handleSubmit}>
              <TextField
                id='outlined-multiline-static'
                name='notificacion'
                label='Notificación'
                className='field-notificacion'
                multiline
                rows={4}
                placeholder='Mensaje...'
                variant='outlined'
                onChange={(notificacion) => { this.handleChange(notificacion) }}

              />
              <div className='opciones-notificacion'>
                <FormControlLabel style={{ width: '60%', margin: '0px' }}
                  control={
                    <Checkbox
                      onChange={this.changePrioridad}
                      name='prioridad'
                      color='primary'
                    />
                  }
                  label='Prioridad'
                />

                <Grid container justify='space-around'>
                  <Field
                    autoOk
                    name='vencimiento'
                    emptyLabel
                    component={renderDateMaterialField}
                    value={vencimiento}
                    autoFocus={false}
                    validate={[required]}
                    helperText='Vencimiento del mensaje'
                    disablePast
                    onChange={(v) => { this.changeVencimiento(v) }}
                    placeholder={``}
                  />
                </Grid>
              </div>
              <div />
              <Button type='submit' className='btn-notififacion' variant='primary'>Confirmar</Button>
            </form>
          </Card>
          {notificaciones.length > 0 && <Card className='shadow bg-white rounded card-notificacion-chofer card-abm-notificaciones'>
            <div>
              { notificaciones.map((n) => (
                <div className='container-mensaje'key={n.notificacion}>
                  <p className='mensaje-abm'>{n.notificacion}</p>
                  <div className='container-mensaje-abm'>
                    <p style={{ color: '#495057' }}>Vencimiento del mensaje: {moment(n.fechaVencimiento).calendar()} hs.</p>
                    <IconButton onClick={() => this.eliminar(n)} ><DeleteIcon /></IconButton>
                  </div>
                </div>
              )) }
            </div>
          </Card> }
        </div>

        <div className='container-funcionalidad-notificacion-vista'>
          <Card className='shadow bg-white rounded card-notificacion-chofer-vista'>
            <div>
              <iframe className='vizualizacion-consulta-cupo' title='notificaciones' src={urlConsulta} id='vistaConsulta' />
            </div>
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  notificacionesChofer: state.camionesIngreso.notificacionesChofer,
  notificacionNueva: selector(state, 'notificacion'),
  notificacionCompleta: selector(state, 'notificacionCompleta'),
  prioridad: selector(state, 'prioridad'),
  vencimiento: selector(state, 'vencimiento')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_NOTIFICACIONES_CHOFER,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(CampoNotificacionChofer))
